export default {"src":"/_next/static/media/Google Play Badge.e29c7bf8.svg","height":40,"width":135};